import React, {  } from 'react';

import { numberFormatOptions } from '../types';
import { IntlFunction } from './Intl.Function';
import { NumberFormatInput, NumberFormatRuleSet } from './Intl.NumberFormat';

export const IntlNumberFormatFormatToParts = () => (
	<IntlFunction
		input={NumberFormatInput}
		mdnLink="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/formatToParts"
		header="Intl.NumberFormat.prototype.formatToParts"
		description="Allows locale-aware formatting of strings produced by **`NumberFormat`** formatters."
		options={numberFormatOptions}
		ruleSet={NumberFormatRuleSet}
		template="new Intl.NumberFormat(##locale##, ##options##).formatToParts(##input:number##)" />
)